export default __webpack_public_path__ + "static/media/organization.25268477.svg";